import axios from 'axios';
import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBCardTitle, MDBAlert,
    MDBCol,
    MDBIcon, MDBBadge,
    MDBRow, MDBCardFooter,
    MDBSpinner, MDBLightbox,
    MDBTooltip, MDBLightboxItem,
    MDBBtnGroup
} from 'mdb-react-ui-kit';
import { useParams, Link } from 'react-router-dom';
import React, { useEffect, useContext, useState } from 'react';
import ReceiptProcessModal from '../receipts/ReceiptProcessModal';
import { deleteHandle, fetchCompanyMap, fetchDocumentMap } from './../utils/Common';
import { UserProfileContext } from '../context/UserProfileProvider';
import { MiscContext } from '../context/MiscProvider';
import TitleProcessModal from '../receipts/TitleProcessModal';
const UnProcessed = () => {

    const [isAtBottom, setIsAtBottom] = useState(false);
    const [showButtons, setShowButtons] = useState(false);
    const handleScroll = () => {
        const scrollPosition = window.scrollY + window.innerHeight;
        const scrollHeight = document.documentElement.scrollHeight;
        setIsAtBottom(scrollPosition >= scrollHeight - 1);
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const scrollToBottom = () => {
        window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    useEffect(() => {
        const checkHeight = () => {
            setShowButtons(document.documentElement.scrollHeight > window.innerHeight);
        };

        checkHeight();
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', checkHeight);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', checkHeight);
        };
    }, []);


    const { setCompaniesMap, setDocumentsMap, companiesMap, documentsMap, receipts, setReceipts, isUploading } = useContext(MiscContext);
    const { tokenLoaded } = useContext(UserProfileContext);
    const { type } = useParams();
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    const [isReceiptToBeProcessed, setIsReceiptToBeProcessed] = useState(false);
    const [isTitleToBeProcessed, setIsTitleToBeProcessed] = useState(false);
    const [companyName, setCompanyName] = useState(null);
    const [alertMessage, setAlertMessage] = useState('Processed');
    const [showAlert, setShowAlert] = useState(false);
    const [typeChange, setTypeChange] = useState(type);
    const [alertColor, setAlertColor] = useState('danger');
    const [unProcessed, setUnProcessed] = useState([]);
    const [totalCount, setTotalCount] = useState(0);


    const calculateTotalCount = (documents) => {
        let totalCount = 0;
        Object.values(documents || {}).forEach(companies => {
            totalCount += companies.length; // Assuming companies is an array of documents
        });
        return totalCount;
    };


    const changeDocumentType = async (receiptId) => {
        try {
            // Make API call to delete receipt
            const endpoint = `${baseUrl}/imgs/${receiptId}/type/${typeChange}`;
            const response = await axios.put(endpoint, {
                withCredentials: true,
            });

            if (response.status === 200) {
                // console.log('Receipt update successfully');
                // setUnProcessed(currentUnProcessed => {
                //     const newUnProcessed = {...currentUnProcessed}; // Create a shallow copy of the unProcessed object
                //     if (newUnProcessed[companyName]) {
                //         // Filter out the receipt with the matching ID
                //         newUnProcessed[companyName] = newUnProcessed[companyName].filter(receipt => receipt.id !== receiptId);
                //          if (newUnProcessed[companyName].length === 0) {
                //            // If no receipts left under this company, remove the company key
                //             delete newUnProcessed[companyName];
                //         }
                //     }
                //     return newUnProcessed;
                // });

                await fetchCompanyMap(setCompaniesMap, tokenLoaded);
                await fetchDocumentMap(setDocumentsMap, tokenLoaded);

                setTotalCount(calculateTotalCount());
            }
            else {
                console.error(`Error: ${response.status}`);
            }
        } catch (err) {
            console.error('An error occurred while deleting receipt:', err);
        }
    };

    useEffect(() => {
        
        const fetchDocData = async () => {
            if (tokenLoaded) { // Assume isDocumentsFetched tracks if fetching is needed
                await fetchDocumentMap(setDocumentsMap, tokenLoaded, type);
                        }
        };
        fetchDocData();
    }, [setDocumentsMap, tokenLoaded, type]); // Only re-run when tokenLoaded changes


    useEffect(() => {
        const fetchCompData = async () => {
            if (tokenLoaded) { // Assume isDocumentsFetched tracks if fetching is needed
                await fetchCompanyMap(setCompaniesMap, tokenLoaded);

            }
        };

        fetchCompData();
    }, [setCompaniesMap, tokenLoaded]); // Only re-run when tokenLoaded changes


    useEffect(() => {
        let newCounts;
        switch (type) {
            case 'other':
                setUnProcessed(documentsMap?.othersUnProcessed);
                setTypeChange('Other');
                newCounts = calculateTotalCount(documentsMap?.othersUnProcessed);
                break;
            case 'invoice':
                setUnProcessed(documentsMap?.invoicesUnProcessed);
                setTypeChange('Invoice');
                newCounts = calculateTotalCount(documentsMap?.invoicesUnProcessed);
                break;
            case 'bill':
                setUnProcessed(documentsMap?.billsUnProcessed);
                setTypeChange('Bill');
                newCounts = calculateTotalCount(documentsMap?.billsUnProcessed);
                break;
            case 'title':
                setUnProcessed(documentsMap?.titlesUnProcessed);
                setTypeChange('Title');
                newCounts = calculateTotalCount(documentsMap?.titlesUnProcessed);
                break;
            case 'picture':
                setUnProcessed(documentsMap?.titlesUnProcessed);
                setTypeChange('Picture');
                newCounts = calculateTotalCount(documentsMap?.titlesUnProcessed);
                break;
            default:
                setUnProcessed(documentsMap?.receiptsUnProcessed);
                setTypeChange('Other');
                newCounts = calculateTotalCount(documentsMap?.receiptsUnProcessed);
                break;
        }
        setTotalCount(newCounts);
    }, [documentsMap, type]);
    return (
        <>

            <MDBAlert open={showAlert} className='text-center' color={alertColor} autohide
                delay={5000}
                position='top-right'
                onClose={() => setShowAlert(false)}>
                <i className="fas fa-check-circle me-3"> <h6 className='alert-heading'>{alertMessage}</h6></i>
                <MDBBtn color='link' onClick={() => setShowAlert(false)}>close</MDBBtn>

            </MDBAlert>

            {isUploading &&


                <div className="d-flex align-items-center justify-content-center mt-3">
                    <MDBSpinner className='mx-2' color='warning'>
                        <span className='visually-hidden'>Loading...</span>
                    </MDBSpinner>
                </div>}
            {isReceiptToBeProcessed && <ReceiptProcessModal isReceiptToBeProcessed={isReceiptToBeProcessed} setIsReceiptToBeProcessed={setIsReceiptToBeProcessed} companyName={companyName} setShowAlert={setShowAlert} />}
            {isTitleToBeProcessed && <TitleProcessModal isTitleToBeProcessed={isTitleToBeProcessed} setIsTitleToBeProcessed={setIsTitleToBeProcessed} companyName={companyName} setShowAlert={setShowAlert} />}
            {(unProcessed && Object.keys(unProcessed) && Object.keys(unProcessed)?.length > 0) ?
                <MDBCard className='text-center'>
                    <MDBCardBody className='justify-content-center'>
                        <MDBRow className="row-cols-1 row-cols-md-2 justify-content-center" >
                            <MDBCard>
                                <MDBCardHeader>
                                    <MDBCardTitle className="text-capitalize">UnProcessed, {type} Documents </MDBCardTitle>
                                    <MDBBtnGroup className='mb-2  text-center  justify-content-center'>
                                        {companiesMap?.length > 0 && <MDBBtn color='warning' href='#' >
                                            <Link to={`/processed/${type}`} style={{ color: 'white' }}>Go To Processed</Link>
                                        </MDBBtn>}
                                        {showButtons &&  <MDBBtn onClick={scrollToBottom}>
                                            <MDBIcon fas icon="arrow-down" /> Go to Bottom</MDBBtn>}
                                        <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#55acee' }}>
                                            <Link to={`/no-receipts/${type}`}><MDBIcon fas icon="cloud-upload-alt" /></Link>
                                        </MDBBtn>
                                    </MDBBtnGroup>
                                </MDBCardHeader>

                                <MDBCardBody>
                                    {unProcessed && Object.keys(unProcessed)
                                        //.sort((a, b) => a.localeCompare(b))
                                        .sort((a, b) => {
                                            // Assuming 'unProcessed' keys are the company names and it contains arrays of receipts
                                            // We need a way to access the first receipt's date to compare, adjust the logic based on your actual data structure
                                            const dateA = new Date(unProcessed[a][0].createdDate);
                                            const dateB = new Date(unProcessed[b][0].createdDate);
                                            return dateB - dateA;  // Sort by date ascending
                                        })

                                        .map((key) => (
                                            <MDBCard key={key} className='mb-2 row-cols-1 row-cols-md-1 justify-content-center'>
                                                <MDBRow className="row-cols-1 row-cols-md-1 justify-content-center" >
                                                    <MDBCol md='10'>
                                                        <span className='font-monospace fw-bolder text-warning text-capitalize'>{key}</span>
                                                        <MDBRow className="row-cols-1 row-cols-md-1 justify-content-center ms-2 align-items-center " >
                                                            {Array.isArray(unProcessed[key]) && unProcessed[key].length > 0 && unProcessed[key].map((doc, index) => (
                                                                <MDBCol key={index} className='mb-2 d-flex align-items-center'>
                                                                    <MDBTooltip wrapperProps={{ color: 'warning' }} title="Please click to view">
                                                                        <MDBLightbox className="d-flex align-items-center justify-content-center">
                                                                            <MDBLightboxItem style={{ width: '60px', height: '80px' }}
                                                                                zoomlevel={0.25}
                                                                                src={doc.url}
                                                                                fullscreenSrc={doc.url}
                                                                            />
                                                                        </MDBLightbox>
                                                                    </MDBTooltip>
                                                                    <div> {/* Margin between tooltip and button */}
                                                                        {key !== 'Miscellaneous' && <MDBBtn color='link' onMouseUp={() => changeDocumentType(doc.id)}>{`Change Type To ${typeChange}`}</MDBBtn>}
                                                                        <MDBBtn color='link' className='text-danger' onMouseUp={() => deleteHandle(doc.id, setAlertColor, setShowAlert, setAlertMessage, receipts, setReceipts, undefined, undefined, setIsReceiptToBeProcessed, undefined, setCompaniesMap, setDocumentsMap, tokenLoaded)}>delete</MDBBtn>

                                                                    </div>
                                                                </MDBCol>

                                                            ))}
                                                        </MDBRow>
                                                        <span style={{ position: 'absolute', top: 10, right: -2 }}>
                                                            <MDBBadge color='danger' light pill className='position-absolute translate-middle'>
                                                                {unProcessed[key].length}
                                                            </MDBBadge>
                                                        </span>
                                                    </MDBCol>
                                                    <MDBCol md="2" className="text-right">
                                                        <MDBBtn size='sm' tag='a' color='link' className='m-1' rippleColor='dark' onClick={() => {
                                                            type === 'receipt' ? setIsReceiptToBeProcessed(true) : setIsTitleToBeProcessed(true);
                                                            //setIsReceiptToBeProcessed(true);
                                                            setCompanyName(key);
                                                        }}>
                                                            {/* <MDBTooltip tag='a' wrapperProps={{ href: '#' }} title="Start Processing..." >
                                                                <MDBIcon fas icon="broom" color='warning' />
                                                            </MDBTooltip> */}
                                                            <text>process</text>

                                                        </MDBBtn>
                                                    </MDBCol>
                                                </MDBRow>
                                            </MDBCard>
                                        ))}

                                </MDBCardBody>

                                {showButtons &&   <MDBCardFooter>
                                    <MDBBtn onClick={scrollToTop} className='mt-2'>
                                        <MDBIcon fas icon="arrow-up" /> Go to Top
                                    </MDBBtn>
                                </MDBCardFooter>}
                            </MDBCard>
                            <span style={{ position: 'absolute', top: 35, right: 25 }}>
                                <MDBBadge color='black' dark className='position-absolute translate-middle'>
                                    {totalCount}
                                </MDBBadge>
                            </span>
                        </MDBRow>
                 </MDBCardBody>
           </MDBCard>
                :
                <div className='p-5 text-center bg-light'>
                    <h1 className='mb-3 text-capitalize'>No UnProcessed Document of Type {type}</h1>
                    {/* <h6 className='mb-3'>Please Go To UnProcessed of Type {type}</h6> */}
                    <MDBBtn color='black' href='#'>
                        <Link to={`/processed/${type}`}>Go ToProcessed</Link>
                    </MDBBtn>
                    <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#55acee' }}>
                        <Link to={`/no-receipts/${type}`}><MDBIcon fas icon="cloud-upload-alt" /></Link>
                    </MDBBtn>



                </div>
            }




        </>
    );

}


export default UnProcessed;